module.exports = __webpack_public_path__ + "static/bg-ce241a447ae2032ad40c9913c04baa0c.png";